import { useEffect } from 'react';
import { connect } from "react-redux";

import { setReplayTracks } from "../actions/index";

// Store `Tick-Mark Tracks Local Session` Management
// Local Storage
let saveToLocal = false;
function ConnectedReplayTracksWrapper({ replayTracks, setReplayTracks }) {

  useEffect( () => {
    if (saveToLocal) {
      localStorage.setItem('RTracks', JSON.stringify([...new Set(replayTracks)])); //Unique
    }
  }, [replayTracks]);

  useEffect( () => {
    const RTracks = JSON.parse(localStorage.getItem('RTracks'));
    saveToLocal = true;
    if (RTracks) {
      setReplayTracks(RTracks);
    }
  }, [setReplayTracks]);

  return null;
}

const ReplayTracksWrapper = connect(
  state => ({
    replayTracks: state.replayTracks
  }),
  dispatch => ({
    setReplayTracks: data => dispatch(setReplayTracks(data))
  })
)(ConnectedReplayTracksWrapper);

export default ReplayTracksWrapper;
